import { PublicMobileVoiceSubscriptions } from '../../../components/PublicMobileVoiceSubscriptions/PublicMobileVoiceSubscriptions.js';

export const AnonymousMobileVoicePath = () => {
  return <PublicMobileVoiceSubscriptions />;
};
